import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useSitzung } from '../sitzung.jsx'
import Icon from '../Icon.jsx'

export default function Anmelden() {
  const { benutzer, laedt, anmelden } = useSitzung()
  const navigate = useNavigate()
  const ort = useLocation()

  const [email, setEmail] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState('')
  const [sendet, setSendet] = useState(false)

  // Wer schon angemeldet ist, hat auf dieser Seite nichts verloren.
  if (!laedt && benutzer) return <Navigate to={ort.state?.von || '/'} replace />

  async function absenden(ereignis) {
    ereignis.preventDefault()
    setFehler('')
    setSendet(true)
    try {
      await anmelden(email, passwort)
      navigate(ort.state?.von || '/', { replace: true })
    } catch (e) {
      setFehler(e.message)
      setPasswort('')
    } finally {
      setSendet(false)
    }
  }

  return (
    <main className="huelle huelle--schmal">
      <div className="anmeldekopf">
        <span className="anmeldekopf__symbol">
          <Icon name="uhr" groesse={26} strich={2} />
        </span>
        <h1>Stundenzettel</h1>
        <p className="untertitel">Arbeitszeiterfassung</p>
      </div>

      <form className="karte" onSubmit={absenden}>
        <div className="feld">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="feld">
          <label htmlFor="passwort">Passwort</label>
          <input
            id="passwort"
            type="password"
            autoComplete="current-password"
            required
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
          />
        </div>

        {fehler && (
          <div className="meldung fehler" role="alert">
            <Icon name="warnung" groesse={18} />
            <span>{fehler}</span>
          </div>
        )}

        <button className="knopf knopf--haupt knopf--breit" type="submit" disabled={sendet}>
          {sendet ? 'Anmelden …' : 'Anmelden'}
        </button>
      </form>

      <p className="hinweis">
        Kein Zugang? Zugänge werden von der Verwaltung angelegt — es gibt keine
        Selbstregistrierung.
      </p>
    </main>
  )
}
